module.exports = __webpack_public_path__ + "img/cave18.28760b64.jpg";